import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: { fullscreen: _vm.$attrs.fullscreen },
      model: {
        value: _vm.value.visibilidade,
        callback: function ($$v) {
          _vm.$set(_vm.value, "visibilidade", $$v)
        },
        expression: "value.visibilidade",
      },
    },
    [
      _c(
        VCard,
        { staticClass: "overflow-hidden", attrs: { flat: "" } },
        [
          _c(
            VAppBar,
            {
              staticClass: "pa-2",
              attrs: {
                absolute: "",
                "elevate-on-scroll": "",
                "scroll-target": "#scrolling-techniques-7",
              },
            },
            [
              _c("h1", { staticClass: "primary--text title" }, [
                _vm._v(" " + _vm._s(_vm.value.titulo) + " "),
              ]),
              _c(VSpacer),
              _c(
                VTooltip,
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              {
                                attrs: { color: "error", text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.value.visibilidade = false
                                  },
                                },
                              },
                              on
                            ),
                            [
                              _c(VIcon, { staticClass: "mr-2" }, [
                                _vm._v(" close "),
                              ]),
                              _vm._v(" Fechar "),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Clique no botão para fechar")])]
              ),
            ],
            1
          ),
          _c(
            VSheet,
            {
              staticClass: "overflow-y-auto mt-12",
              attrs: { id: "scrolling-techniques-7" },
            },
            [
              _c(
                VContainer,
                { style: `height:${_vm.altura}px;`, attrs: { id: "view" } },
                [_vm._t("body")],
                2
              ),
            ],
            1
          ),
          _c(
            VCardActions,
            { staticClass: "pa-4 ma-2" },
            [_c(VSpacer), _vm._t("actions")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }